UTIL.registerTask('freedownloads', 'download', function () {

    (function ($) {

        $(document).ready(function() {
            $("#free-download-agreement-form").validate({
                rules: {
                    agreement_agreed: "required"
                },
                messages: {
                    agreement_agreed: "You must confirm you agree to the terms and conditions"
                },
                errorPlacement: function(error, element) {
                    error.appendTo($("#confirm-agreement-label"));
                },
                errorClass: "agreement-not-confirmed"
            });
        });

    })(jQuery);
});